import { BaseSurvey } from '../base-survey';
import { validateESCTriggerCondition } from '../utils';
import { EscWebuiUserPauseCampaignSurveyView } from './view';

export class EscWebuiUserPauseCampaignSurvey extends BaseSurvey {
  getSurveyName = () => 'EscWebuiUserPauseCampaignSurvey';

  getSurveyId = () => '7f329cc3-a70f-4477-8ecd-31751102880c';

  validateTriggerCondition = () => validateESCTriggerCondition(this, 'ESCUserPauseCampaign');

  onSurveySubmit = () => {
    window.survey.ESCUserPauseCampaign = false;
    delete window.survey.ESCUserPauseCampaignCustomParams;
  };

  onSurveyDismiss = () => {
    window.survey.ESCUserPauseCampaign = false;
    delete window.survey.ESCUserPauseCampaignCustomParams;
  };

  getSurveyComponent = () => EscWebuiUserPauseCampaignSurveyView;

  getSurveyCustomParams = () => window.survey.ESCUserPauseCampaignCustomParams;
}
